<template>
  <div>
    <!--SEARCH BRIDGE-->
    <SearchAndResult />
    <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>
    <div class="Vlt-grid flexContainer">
      <!--REFRESH BUTTON-->
      <div class="Vlt-col Vlt-col--2of4 Vlt-left"></div>
      <div class="Vlt-col Vlt-col--2of4 Vlt-left">
        <div class="Vlt-margin--A-bottom2">
          <div class="tooltip-item" >
            <vlt-tooltip
              icon="info"
              :title="$t('message.dashboard.refresh_bridges')"
              position="right"
            >
              <vlt-button
                name="refresh"
                primary
                app
                icon="refresh"
                :tooltipTitle= "$t('message.refresh')"
                @click="refreshBridgesList"
                :disabled="reloadingBridges"
              />
            </vlt-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="Vlt-grid__separator"><!-- Empty line breaker --></div>
    <div >
      <!--SEARCH-->
      <h4>
        <span>
          <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="search"/>
        </span>&nbsp;
        {{$t('message.dashboard.searchNumber.search_number')}}
      </h4>
      <div  class="Vlt-grid Vlt-margin--A-bottom2">
        <!--SEARCH-->
        <div class="Vlt-col Vlt-col--2of4">
          <div class="Vlt-composite">
            <div class="Vlt-composite__prepend Vlt-composite__prepend--icon">
              <div class="Vlt-composite__icon">
                <vlt-icon class="Vlt-grey Vlt-margin--bottom1" icon="search" small/>
              </div>
            </div>
            <div class="Vlt-input">
              <input
                type="search"
                id="search-input-icon-button"
                autocomplete="off"
                :placeholder="$t('message.dashboard.searchNumber.search_number')"
                v-model="filter"/>
            </div>
          </div>
        </div>
      </div>
      <div>
        <vlt-callout v-if="bridgeError" type="critical">
          <h4>Bridge error</h4>
          <p>{{$t('message.errors.bridge_error')}}</p>
        </vlt-callout>
      </div>

<!--  DATA TABLE-->
      <div class="Vlt-grid flexContainer">
        <div class="Vlt-col">
          <table-cell-edit
            :loading="loading || reloadingBridges"
            :columns="columns"
            :filteredData="filtered"
            :pageSize="pageSize"
            :saveDescription="onSave"
            :editableTable="isAdmin"
            :userStatus="userStatus"
            :terminateBridge="hangUpBridge"
            :joinABridge="onJoin"
            :emptyMessage="$t('message.dashboard.no_records')"
          />
        </div>
      </div>

    </div>
    <!--    NO RESULTS-->
<!--    <div v-else>-->
<!--      <div class="Vlt-empty">-->
<!--        <div class="Vlt-empty__content">-->
<!--          {{$t('message.dashboard.searchNumber.no_results')}}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TableCellEdit from './TableCellEdit';
import {
  VltIcon,
  VltButton,
  VltSpinner,
  VltTable,
  VltCallout,
  VltField,
  VltInput,
  VltTooltip,
} from '@vonagevolta/vue';

import SearchAndResult from 'Components/common/SearchAndResult';
import {
  UPDATE_FEED_DESCRIPTION,
  GET_USER_HISTORY,
  GET_ALL_BRIDGES,
  HANG_UP_BRIDGE,
  MAKE_A_CALL,
} from 'Store/action-types';
import {
    SET_BRIDGE_ERROR,
} from 'Store/mutation-types';

export default {
  name: 'AdminSearchAndListBridges',
  components: {
    VltIcon,
    VltButton,
    VltSpinner,
    VltTable,
    TableCellEdit,
    VltCallout,
    VltField,
    VltInput,
    VltTooltip,
    SearchAndResult,
  },
  props: {},
  data() {
    return {
      filter: '',
      filteredNumbers: [],
      fuseOptions: {
        shouldSort: true,
        minMatchCharLength: 2,
        threshold: 0.2,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        keys: [
          {
            name: 'feedNumber',
            weight: 1,
          },
        ],
      },
      debounce: null,
      term: '',
      columns: [
          { title: 'Number', property: 'feedNumber', sortable: true },
          { title: 'Description', property: 'feedDescription', sortable: false },
          { title: 'Captioners' },
          { title: 'Action'},
      ],
      pageSize: 10,
      editCell: '',
      initEditValue: '',
      editing: false,
      termError: '',
      newNumber: '',
      newNumberTermErr: '',
      processing: false,
      isConnecting: false,
      reloadingBridges: false,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: 'isAdmin',
      userStatus: 'getUserStatus',
      inConversation: 'getInConversation',
      allBridges: "getAllBridges",
      loading: 'getLoading',
      bridgeError: 'getBridgeError',
    }),
    filtered() {
      return this.filteredNumbers && this.filteredNumbers.length > 0
        ? this.filteredNumbers
        : !this.filteredNumbers.length && this.term ? [] : this.numbers;
    },
  },
  watch: {
    async filter(term) {
      if (!term || !term.trim()) {
        this.filteredNumbers = this.allBridges;
      } else {
//        this.filteredNumbers = await this.$search(term, this.entities, this.fuseOptions);
          this.debounceSearch(term);
      }

    },
    userStatus: {
        immediate: true,
        handler(newProp) {
          // console.log('=========== Admin userStatus: ', newProp);
        },
    },
    allBridges: {
      immediate: true,
      handler(newProp) {
        // console.log('=========== ALL bridges: ', newProp);
         this.filteredNumbers = newProp;
      },
    },
    loading(current) {
        // console.log('current LOADING: ', current)
    },
    bridgeError(current) {
      console.log('bridge error: ', current)
    },

  },
  methods: {
    ...mapMutations({
      setBridgeErr: `${SET_BRIDGE_ERROR}`,
    }),
    async refreshBridgesList() {
    this.setBridgeErr(null);
      this.reloadingBridges = true;
      await this.fetchAllBridges();
      this.reloadingBridges = false;
    },
    onLeaveWithoutSave(e) {
      if (this.editing) {
        this.editing = false;
        return;
      }

      const id = e.target.id;
      const numid  = id.substring(id.lastIndexOf('-') + 1);
      const item = this.filtered.find((item)=> item.number===numid);
      if (item) {
        item.desc = this.initEditValue;
      }
      this.initEditValue = '';
      this.editCell = '';
    },
    async onSave(e) {
        this.editCell = '';
        this.editing = true;
        const newDescValue = e.value.trim();

        if (newDescValue === this.initEditValue) {
            return;
        }
        const params = { description: newDescValue, feedNumber:  e.numId };
        await this.saveFeedDescription(params);
        this.editing = false;
    },

    debounceSearch(term) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout( async () => {
        this.term = term;
        // console.log('Term: ', this.term);
        this.filteredNumbers = await this.$search(term, this.allBridges, this.fuseOptions);
        // console.log('this.filteredNumbers: ',this.filteredNumbers)
      }, 600)
    },
    ...mapActions({
      fetchNumbers:  `${GET_USER_HISTORY}`,
      fetchAllBridges:  `${GET_ALL_BRIDGES}`,
      saveFeedDescription: `${UPDATE_FEED_DESCRIPTION}`,
      hangUpBridge: `${HANG_UP_BRIDGE}`,
      makeACall: `${MAKE_A_CALL}`,
    }),
    init() {
      // this.fetchNumbers();
      let id = setInterval(() =>{
        if (!this.loading) {
          clearInterval(id);
          this.fetchAllBridges();
        }
      },2000);
    },
    onChangeField() {
        // clean up errors
        this.termError = null;
    },
    async onJoin(params) {
      await this.makeACall(params);
      this.fetchAllBridges();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
  .paddingRight20 {
    padding-right: 20px;
  }

  .paddingLeft20 {
    padding-left: 28px;
  }

  .flexContainer {
    display: flex;
    align-items: stretch;
    //justify-content: space-between;
  }

  .appBoxWidth {
    width: 380px;
  }

  .stretch-height {
    height: 100%;
  }

  .width100percent {
    width: 100%;
  }

  .Vlt-btn--uppercase {
    text-transform: uppercase;
  }

  .previewContent {
    height: 240px;
    max-height: 240px;
    display: flex;
    flex-direction: column;
  }
  .previewTextContent {
    flex: 1 0 auto;
    overflow: auto;
    max-height: 188px;
    .previewText {
      max-height: 80px;
      overflow: auto;
    }
  }
</style>
